import {
    multiAccountEquityPortfolioImpact,
    MultiAccountEquityPortfolioImpact
} from "./steps/equity-portfolio-impact/EquityPortfolioImpactComponent";
import {MultiAccountEquityOrderWizard, placeMultiAccountEquityWizard} from "./MultiAccountEquityOrderWizard";
import {multiAccountOrdersStep, MultiAccountOrderStep} from "./steps/multi-account-orders-step/MultiAccountOrderStep";
import {
    multiAccountEquityOrderConfirm,
    MultiAccountEquityOrderConfirm
} from "./steps/confirm-step/MultiAccountEquityOrderConfirmStep";
import {MultiDuplicateOrdersNotificationDialog} from "./dialog/MultiDuplicateOrdersNotificationDialog";

export default angular.module("tfApp.portfolio.multi-account-equity-order-wizard", [])
                      .component(MultiAccountEquityOrderWizard, placeMultiAccountEquityWizard())
                      .component(MultiAccountOrderStep, multiAccountOrdersStep())
                      .component(MultiAccountEquityOrderConfirm, multiAccountEquityOrderConfirm())
                      .component(MultiAccountEquityPortfolioImpact, multiAccountEquityPortfolioImpact())
                      .service(MultiDuplicateOrdersNotificationDialog.id, MultiDuplicateOrdersNotificationDialog)
                      .name;
